import React, { FC } from 'react';
import './RequiredNote.css';

interface RequiredNoteProps {}

const RequiredNote: FC<RequiredNoteProps> = () => (
  <div className="RequiredNote" data-testid="RequiredNote">
    <span className="asterisk">(*)</span> Champ requis
  </div>
);

export default RequiredNote;